import { IconButton } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Toolbar from '@material-ui/core/Toolbar';
import { Assessment } from '@material-ui/icons';
// material-ui icons
import Menu from '@material-ui/icons/Menu';
import headerStyle from 'assets/jss/material-dashboard-pro-react/components/headerStyle.jsx';
import cx from 'classnames';
import Button from 'components/CustomButtons/Button.jsx';
import TaskList from 'components/SqTasks/TaskList.jsx';
import PropTypes from 'prop-types';
import React from 'react';
import { toggleProgressOpen } from 'reducers/TasksReducer';
import store from 'store';
import './Header.css';
// core components
import HeaderLinks from './HeaderLinks';

function Header({ ...props }) {
	const { logo } = props;
	function handleOpenTask() {
		store.dispatch(toggleProgressOpen());
	}

	function goToHome(e) {
		props.history.push({
			pathname: '/app/home'
		});
	}

	const { classes, color, rtlActive } = props;
	const appBarClasses = cx({
		[' ' + classes[color]]: color
	});
	const sidebarMinimize =
		classes.sidebarMinimize +
		' ' +
		cx({
			[classes.sidebarMinimizeRTL]: rtlActive
		});

	var brand = (
		<div className="logoContainer">
			<div className={classes.logo}>
				<a href="" onClick={e => goToHome(e)} className={classes.logoMini}>
					<img
						src={logo}
						alt="logo"
						className={classes.img}
						style={{ marginTop: '-30px', width: '125px', marginBottom: '8px' }}
					/>
				</a>
			</div>
		</div>
	);

	return (
		<div className="appBarHeaderSQ">
			<AppBar className={classes.appBar + appBarClasses}>
				<Toolbar className={classes.container}>
					<Hidden smDown>
						<div className={sidebarMinimize} />
					</Hidden>

					<div
						className={classes.flex}
						style={{ textAlign: 'center', display: 'flex' }}
					>
						{brand}
					</div>
					<Hidden smDown implementation="css">
						<HeaderLinks rtlActive={rtlActive} />
					</Hidden>
					<Hidden mdUp>
						<IconButton onClick={() => handleOpenTask()}>
							<Assessment />
						</IconButton>

						<TaskList />

						<Button
							className={classes.appResponsive}
							color="transparent"
							justIcon
							aria-label="open drawer"
							onClick={props.handleDrawerToggle}
						>
							<Menu />
						</Button>
					</Hidden>
				</Toolbar>
			</AppBar>
		</div>
	);
}

Header.propTypes = {
	classes: PropTypes.object.isRequired,
	color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
	rtlActive: PropTypes.bool
};

export default withStyles(headerStyle)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx